export default "/static/dashboard/build/app/img/v2/cb675a119eabe149bf1606e502bdcf40.png";